// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1ecqC","icon":"SortAdornment_icon__3nFwm","up":"SortAdornment_up__1XeMa","down":"SortAdornment_down__2aDhS","active":"SortAdornment_active__PZZin"};